import { Switch, Route } from 'react-router-dom';
import { MainPage } from './components/main-page';
import { LoginPage } from './components/login-page';

export const AppRouter = () => {
    return (
        <Switch>
            <Route path="/" exact component={MainPage} />
            <Route path="/login" exact component={LoginPage} />
        </Switch>
    );
};
